/**
 * String value of enum represents the css variable of the color name.
 *
 * For ex Primary = 'var(--theme-colors-primary-wlv)'
 *
 * '-wlv' indicates 'white label value', meaning it can be/is white label-overridden.
 */
export var ThemeColorVariable;
(function (ThemeColorVariable) {
    ThemeColorVariable["Primary"] = "var(--theme-colors-primary-wlv)";
    ThemeColorVariable["PrimaryHover"] = "var(--theme-colors-primary-hover-wlv)";
    ThemeColorVariable["PrimaryActive"] = "var(--theme-colors-primary-active-wlv)";
    ThemeColorVariable["OnPrimary"] = "var(--theme-colors-on-primary-wlv)";
    ThemeColorVariable["PrimaryContainer"] = "var(--theme-colors-primary-container-wlv)";
    ThemeColorVariable["OnPrimaryContainer"] = "var(--theme-colors-on-primary-container-wlv)";
    ThemeColorVariable["Secondary"] = "var(--theme-colors-secondary-wlv)";
    ThemeColorVariable["SecondaryHover"] = "var(--theme-colors-secondary-hover-wlv)";
    ThemeColorVariable["SecondaryActive"] = "var(--theme-colors-secondary-active-wlv)";
    ThemeColorVariable["OnSecondary"] = "var(--theme-colors-on-secondary-wlv)";
    ThemeColorVariable["SecondaryContainer"] = "var(--theme-colors-secondary-container-wlv)";
    ThemeColorVariable["OnSecondaryContainer"] = "var(--theme-colors-on-secondary-container-wlv)";
    ThemeColorVariable["Accent"] = "var(--theme-colors-accent-wlv)";
    ThemeColorVariable["AccentHover"] = "var(--theme-colors-accent-hover-wlv)";
    ThemeColorVariable["AccentHoverAlpha"] = "var(--theme-colors-accent-hover-alpha-wlv)";
    ThemeColorVariable["AccentActive"] = "var(--theme-colors-accent-active-wlv)";
    ThemeColorVariable["AccentActiveAlpha"] = "var(--theme-colors-accent-active-alpha-wlv)";
    ThemeColorVariable["OnAccent"] = "var(--theme-colors-on-accent-wlv)";
    ThemeColorVariable["AccentContainer"] = "var(--theme-colors-accent-container-wlv)";
    ThemeColorVariable["OnAccentContainer"] = "var(--theme-colors-on-accent-container-wlv)";
    ThemeColorVariable["Background"] = "var(--theme-colors-background-wlv)";
    ThemeColorVariable["OnBackground"] = "var(--theme-colors-on-background-wlv)";
    ThemeColorVariable["OnBackgroundBorder"] = "var(--theme-colors-on-background-border-wlv)";
    ThemeColorVariable["OnBackgroundSubdued"] = "var(--theme-colors-on-background-subdued-wlv)";
    ThemeColorVariable["BackgroundDisabled"] = "var(--theme-colors-background-disabled-wlv)";
    ThemeColorVariable["OnBackgroundHeader"] = "var(--theme-colors-on-background-header-wlv)";
    ThemeColorVariable["Surface"] = "var(--theme-colors-surface-wlv)";
    ThemeColorVariable["OnSurface"] = "var(--theme-colors-on-surface-wlv)";
    ThemeColorVariable["OnSurfaceBorder"] = "var(--theme-colors-on-surface-border-wlv)";
    ThemeColorVariable["OnSurfaceSubdued"] = "var(--theme-colors-on-surface-subdued-wlv)";
    ThemeColorVariable["SurfaceDisabled"] = "var(--theme-colors-surface-disabled-wlv)";
    ThemeColorVariable["OnSurfaceHeader"] = "var(--theme-colors-on-surface-header-wlv)";
    ThemeColorVariable["Info"] = "var(--theme-colors-info-wlv)";
    ThemeColorVariable["InfoHover"] = "var(--theme-colors-info-hover-wlv)";
    ThemeColorVariable["InfoActive"] = "var(--theme-colors-info-active-wlv)";
    ThemeColorVariable["OnInfo"] = "var(--theme-colors-on-info-wlv)";
    ThemeColorVariable["InfoContainer"] = "var(--theme-colors-info-container-wlv)";
    ThemeColorVariable["OnInfoContainer"] = "var(--theme-colors-on-info-container-wlv)";
    ThemeColorVariable["Success"] = "var(--theme-colors-success-wlv)";
    ThemeColorVariable["SuccessHover"] = "var(--theme-colors-success-hover-wlv)";
    ThemeColorVariable["SuccessActive"] = "var(--theme-colors-success-active-wlv)";
    ThemeColorVariable["OnSuccess"] = "var(--theme-colors-on-success-wlv)";
    ThemeColorVariable["SuccessContainer"] = "var(--theme-colors-success-container-wlv)";
    ThemeColorVariable["OnSuccessContainer"] = "var(--theme-colors-on-success-container-wlv)";
    ThemeColorVariable["Warning"] = "var(--theme-colors-warning-wlv)";
    ThemeColorVariable["WarningHover"] = "var(--theme-colors-warning-hover-wlv)";
    ThemeColorVariable["WarningActive"] = "var(--theme-colors-warning-active-wlv)";
    ThemeColorVariable["OnWarning"] = "var(--theme-colors-on-warning-wlv)";
    ThemeColorVariable["WarningContainer"] = "var(--theme-colors-warning-container-wlv)";
    ThemeColorVariable["OnWarningContainer"] = "var(--theme-colors-on-warning-container-wlv)";
    ThemeColorVariable["Error"] = "var(--theme-colors-error-wlv)";
    ThemeColorVariable["ErrorHover"] = "var(--theme-colors-error-hover-wlv)";
    ThemeColorVariable["ErrorActive"] = "var(--theme-colors-error-active-wlv)";
    ThemeColorVariable["OnError"] = "var(--theme-colors-on-error-wlv)";
    ThemeColorVariable["ErrorContainer"] = "var(--theme-colors-error-container-wlv)";
    ThemeColorVariable["OnErrorContainer"] = "var(--theme-colors-on-error-container-wlv)";
    ThemeColorVariable["Neutral"] = "var(--theme-colors-neutral-wlv)";
    ThemeColorVariable["NeutralHover"] = "var(--theme-colors-neutral-hover-wlv)";
    ThemeColorVariable["NeutralActive"] = "var(--theme-colors-neutral-active-wlv)";
    ThemeColorVariable["OnNeutral"] = "var(--theme-colors-on-neutral-wlv)";
    ThemeColorVariable["NeutralContainer"] = "var(--theme-colors-neutral-container-wlv)";
    ThemeColorVariable["OnNeutralContainer"] = "var(--theme-colors-on-neutral-container-wlv)";
    // Non white label colors (missing -wlv suffix):
    ThemeColorVariable["Shadow"] = "var(--theme-colors-shadow)";
    ThemeColorVariable["ModalOverlay"] = "var(--theme-colors-modal-overlay)";
    ThemeColorVariable["ViewFinderOverlay"] = "var(--theme-colors-view-finder-overlay)";
    ThemeColorVariable["ShadowHeader"] = "var(--theme-colors-shadow-header)";
    ThemeColorVariable["ShadowFooter"] = "var(--theme-colors-shadow-footer)";
    ThemeColorVariable["ShadowCard"] = "var(--theme-colors-shadow-card)";
    ThemeColorVariable["ShadowScroll"] = "var(--theme-colors-shadow-scroll)";
    ThemeColorVariable["PickerOnPicker"] = "var(--theme-colors-picker-on-picker)";
    ThemeColorVariable["PickerBerry"] = "var(--theme-colors-picker-berry)";
    ThemeColorVariable["PickerBerryLight"] = "var(--theme-colors-picker-berry-light)";
    ThemeColorVariable["PickerCoral"] = "var(--theme-colors-picker-coral)";
    ThemeColorVariable["PickerCoralLight"] = "var(--theme-colors-picker-coral-light)";
    ThemeColorVariable["PickerFlamingo"] = "var(--theme-colors-picker-flamingo)";
    ThemeColorVariable["PickerFlamingoLight"] = "var(--theme-colors-picker-flamingo-light)";
    ThemeColorVariable["PickerFog"] = "var(--theme-colors-picker-fog)";
    ThemeColorVariable["PickerFogLight"] = "var(--theme-colors-picker-fog-light)";
    ThemeColorVariable["PickerHoney"] = "var(--theme-colors-picker-honey)";
    ThemeColorVariable["PickerHoneyLight"] = "var(--theme-colors-picker-honey-light)";
    ThemeColorVariable["PickerLemon"] = "var(--theme-colors-picker-lemon)";
    ThemeColorVariable["PickerLemonLight"] = "var(--theme-colors-picker-lemon-light)";
    ThemeColorVariable["PickerLime"] = "var(--theme-colors-picker-lime)";
    ThemeColorVariable["PickerLimeLight"] = "var(--theme-colors-picker-lime-light)";
    ThemeColorVariable["PickerOlive"] = "var(--theme-colors-picker-olive)";
    ThemeColorVariable["PickerOliveLight"] = "var(--theme-colors-picker-olive-light)";
    ThemeColorVariable["PickerPlum"] = "var(--theme-colors-picker-plum)";
    ThemeColorVariable["PickerPlumLight"] = "var(--theme-colors-picker-plum-light)";
    ThemeColorVariable["PickerSky"] = "var(--theme-colors-picker-sky)";
    ThemeColorVariable["PickerSkyLight"] = "var(--theme-colors-picker-sky-light)";
})(ThemeColorVariable || (ThemeColorVariable = {}));
/**
 * String value of enum represents the css variable of the corresponding theme variable name.
 * For ex ThemeSpaceVariable.Small = 'var(--theme-space-small)'
 */
export var ThemeSpaceVariable;
(function (ThemeSpaceVariable) {
    /** 0 */
    ThemeSpaceVariable["None"] = "var(--theme-space-none)";
    /** 0.25rem / 4px */
    ThemeSpaceVariable["XSmall"] = "var(--theme-space-xsmall)";
    /** 0.5rem / 8px */
    ThemeSpaceVariable["Small"] = "var(--theme-space-small)";
    /** 1rem / 16px */
    ThemeSpaceVariable["Medium"] = "var(--theme-space-medium)";
    /** 2rem / 32px */
    ThemeSpaceVariable["Large"] = "var(--theme-space-large)";
    /** 3rem / 48px */
    ThemeSpaceVariable["XLarge"] = "var(--theme-space-xlarge)";
    /** 5rem / 80px */
    ThemeSpaceVariable["X2Large"] = "var(--theme-space-x2large)";
})(ThemeSpaceVariable || (ThemeSpaceVariable = {}));
export var ThemeBorderVariable;
(function (ThemeBorderVariable) {
    /** 'none' */
    ThemeBorderVariable["None"] = "var(--theme-borders-none)";
    /** '0.0625rem solid' / '1px solid' */
    ThemeBorderVariable["XSmall"] = "var(--theme-borders-xsmall)";
    /** '0.125rem solid' / '2px solid' */
    ThemeBorderVariable["Small"] = "var(--theme-borders-small)";
    /** '0.25rem solid' / '4px solid' */
    ThemeBorderVariable["Medium"] = "var(--theme-borders-medium)";
    /** '0.5rem solid' / '8px solid' */
    ThemeBorderVariable["Large"] = "var(--theme-borders-large)";
    /** '0.5rem solid' / '8px solid', purposly same as large for now */
    ThemeBorderVariable["XLarge"] = "var(--theme-borders-xlarge)";
})(ThemeBorderVariable || (ThemeBorderVariable = {}));
export var ThemeRadiusVariable;
(function (ThemeRadiusVariable) {
    /** 0 */
    ThemeRadiusVariable["None"] = "var(--theme-radii-none)";
    /** 0.125rem / 2px */
    ThemeRadiusVariable["XSmall"] = "var(--theme-radii-xsmall)";
    /** 0.25rem / 4px */
    ThemeRadiusVariable["Small"] = "var(--theme-radii-small)";
    /** 0.5rem / 8px */
    ThemeRadiusVariable["Medium"] = "var(--theme-radii-medium)";
    /** 1rem / 16px */
    ThemeRadiusVariable["Large"] = "var(--theme-radii-large)";
    /** 31.25rem / 500px */
    ThemeRadiusVariable["XLarge"] = "var(--theme-radii-xlarge)";
})(ThemeRadiusVariable || (ThemeRadiusVariable = {}));
export var ThemeFontVariable;
(function (ThemeFontVariable) {
    ThemeFontVariable["Header"] = "var(--theme-fonts-header-wlv)";
    ThemeFontVariable["SubHeader"] = "var(--theme-fonts-subheader-wlv)";
    ThemeFontVariable["Body"] = "var(--theme-fonts-body-wlv)";
})(ThemeFontVariable || (ThemeFontVariable = {}));
export var ThemeFontSizeVariable;
(function (ThemeFontSizeVariable) {
    /** 0.75rem / 12px */
    ThemeFontSizeVariable["XSmall"] = "var(--theme-fontSizes-xsmall)";
    /** 0.875rem / 14px */
    ThemeFontSizeVariable["Small"] = "var(--theme-fontSizes-small)";
    /** 1rem / 16px */
    ThemeFontSizeVariable["Medium"] = "var(--theme-fontSizes-medium)";
    /** 1.125rem / 18px */
    ThemeFontSizeVariable["Large"] = "var(--theme-fontSizes-large)";
    /** 1.5rem / 24px */
    ThemeFontSizeVariable["XLarge"] = "var(--theme-fontSizes-xlarge)";
    /** 2rem / 32px */
    ThemeFontSizeVariable["X2Large"] = "var(--theme-fontSizes-x2large)";
    /** 2.5 rem / 40px */
    ThemeFontSizeVariable["X3Large"] = "var(--theme-fontSizes-x3large)";
    /** 3.25 rem / 52px */
    ThemeFontSizeVariable["X4Large"] = "var(--theme-fontSizes-x4large)";
    /** 4rem / 64px */
    ThemeFontSizeVariable["X5Large"] = "var(--theme-fontSizes-x5large)";
    /** 5rem / 80px */
    ThemeFontSizeVariable["X6Large"] = "var(--theme-fontSizes-x6large)";
})(ThemeFontSizeVariable || (ThemeFontSizeVariable = {}));
export var ThemeShadowVariable;
(function (ThemeShadowVariable) {
    ThemeShadowVariable["Small"] = "var(--theme-shadows-small)";
    ThemeShadowVariable["Medium"] = "var(--theme-shadows-medium)";
    ThemeShadowVariable["Large"] = "var(--theme-shadows-large)";
    ThemeShadowVariable["Header"] = "var(--theme-shadows-header)";
    ThemeShadowVariable["Footer"] = "var(--theme-shadows-footer)";
})(ThemeShadowVariable || (ThemeShadowVariable = {}));
export var ThemeBreakPointVariable;
(function (ThemeBreakPointVariable) {
    /** 0em / 0px */
    ThemeBreakPointVariable["Base"] = "var(--theme-breakpoints-base)";
    /** 30em / 480px */
    ThemeBreakPointVariable["Small"] = "var(--theme-breakpoints-small)";
    /** 48em / 768px */
    ThemeBreakPointVariable["Medium"] = "var(--theme-breakpoints-medium)";
    /** 62em / 992px */
    ThemeBreakPointVariable["Large"] = "var(--theme-breakpoints-large)";
    /** 80em / 1280px */
    ThemeBreakPointVariable["XLarge"] = "var(--theme-breakpoints-xlarge)";
    /** 96em / 1536px */
    ThemeBreakPointVariable["X2Large"] = "var(--theme-breakpoints-x2large)";
})(ThemeBreakPointVariable || (ThemeBreakPointVariable = {}));
export var ThemeIconSizeVariable;
(function (ThemeIconSizeVariable) {
    /** 1rem / 16px */
    ThemeIconSizeVariable["XSmall"] = "var(--theme-iconSizes-xsmall)";
    /** 1.25rem / 20px */
    ThemeIconSizeVariable["Small"] = "var(--theme-iconSizes-small)";
    /** 1.5rem / 24px */
    ThemeIconSizeVariable["Medium"] = "var(--theme-iconSizes-medium)";
    /** 2rem / 32px */
    ThemeIconSizeVariable["Large"] = "var(--theme-iconSizes-large)";
    /** 2.5rem / 40px */
    ThemeIconSizeVariable["XLarge"] = "var(--theme-iconSizes-xlarge)";
    /** 3rem / 48px */
    ThemeIconSizeVariable["X2Large"] = "var(--theme-iconSizes-x2large)";
    /** 3.5rem / 56px */
    ThemeIconSizeVariable["X3Large"] = "var(--theme-iconSizes-x3large)";
})(ThemeIconSizeVariable || (ThemeIconSizeVariable = {}));
//# sourceMappingURL=theme-types.js.map